var _line, _line2, _line3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 45,
    viewBox: "0 0 288 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 23,
    x2: 3.5,
    y2: 4,
    stroke: "#707070"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 284.5,
    y1: 41,
    x2: 284.5,
    y2: 22,
    stroke: "#707070"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 285,
    y1: 22.5,
    x2: 3,
    y2: 22.5,
    stroke: "#707070"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#444444"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.5,
    cy: 41.5,
    r: 3.5,
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateline);
export default __webpack_public_path__ + "static/media/dateline.455e2156b63e0f15f7f36e45252b932b.svg";
export { ForwardRef as ReactComponent };